import {
    giphyBlue,
    giphyGreen,
    giphyIndigo,
    giphyLightBlue,
    giphyPink,
    giphyPurple,
    giphyRed,
    giphyYellow,
} from '@giphy/js-brand'

export const gradients = [
    'blue-green',
    'blue-red',
    'indigo-blue',
    'indigo-cyan',
    'indigo-purple',
    'purple-cyan',
    'purple-green',
    'purple-pink',
    'purple-yellow',
    'red-pink',
    'red-yellow',
] as const

type Gradient = typeof gradients[number]

/**
 * Returns an array of the gradient's hex color values.
 */
export function gradientColors(gradient: Gradient): string[] {
    switch (gradient) {
        case 'blue-green':
            return [giphyBlue, giphyGreen]
        case 'blue-red':
            return [giphyBlue, giphyRed]
        case 'indigo-blue':
            return [giphyIndigo, giphyBlue]
        case 'indigo-cyan':
            return [giphyIndigo, giphyLightBlue]
        case 'indigo-purple':
            return [giphyIndigo, giphyPurple]
        case 'purple-cyan':
            return [giphyPurple, giphyLightBlue]
        case 'purple-green':
            return [giphyPurple, giphyGreen]
        case 'purple-pink':
            return [giphyPurple, giphyPink]
        case 'purple-yellow':
            return [giphyPurple, giphyYellow]
        case 'red-pink':
            return [giphyRed, giphyPink]
        case 'red-yellow':
            return [giphyRed, giphyYellow]
    }
}

/**
 * Returns the gradient's CSS linear-gradient string.
 */
export function gradientCss(gradient: Gradient): string {
    const colors = gradientColors(gradient)
    return `linear-gradient(45deg, ${colors.join(', ')})`
}

export default Gradient
